import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import React from 'react';
import { usePreferredTheme } from '../hooks/usePreferredTheme';

interface ThemeWrapperProps {
    children: React.ReactNode;
}

/**
 * ThemeWrapper component that provides theme with user preference support
 */
export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
    // Use enhanced theme hook with user preference support
    const { theme } = usePreferredTheme();

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default ThemeWrapper;
